import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import { useFlowContext } from '_/contexts/FlowContext';
import { useFlowList } from '_/hooks/useFlows';
import React, { ReactElement } from 'react';

import NewProjectFlow from '../NewProjectFlow';

function EditFlowContainer(): ReactElement {
  const { projectId, collections, isLoading: isLoadingFlow, isLoadingCollections } = useFlowContext();

  // Fetch flow list for validation (checking duplicate names/slugs)
  const { data: flowList = [], isLoading: isLoadingFlowList } = useFlowList(projectId);

  const isLoading = isLoadingFlow || isLoadingCollections || isLoadingFlowList;

  return (
    <AsyncPageContainer isLoading={isLoading}>
      <NewProjectFlow collections={collections || []} flows={flowList || []} />
    </AsyncPageContainer>
  );
}

export default EditFlowContainer;
